import type { ResolvedLevel } from './load-level';
import { ASSIST, GROUND_Y, WORLD_TOP } from './tuning';

/**
 * Assist mode applied to a level (GDD §13.6, issue #138): a working copy with the scroll at 80 % and every gap 15 % taller,
 * growing around its centre. A gap that would leave the playfield (y 1 to y 12) is moved to fit without losing height. The
 * level data of `src/data` is never touched, and the copy keeps every enemy, pickup and checkpoint as they are, so what is
 * defined relative to the scroll (EN-01, EN-03...) follows the effective speed and the absolute speeds do not change.
 */
export function assistLevel(level: ResolvedLevel): ResolvedLevel {
  const columns = level.columns.map((column) => {
    const gapH = column.gapH * ASSIST.gapFactor;
    // Centre kept; the gap is moved only as far as it takes to stay between the ground and the ceiling.
    const gapY = Math.min(WORLD_TOP - gapH / 2, Math.max(GROUND_Y + gapH / 2, column.gapY));
    return { ...column, gapH, gapY };
  });
  return Object.freeze({
    ...level,
    def: Object.freeze({ ...level.def, scrollSpeed: level.def.scrollSpeed * ASSIST.scrollFactor }),
    columns: Object.freeze(columns),
  });
}
